import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EnrollmentOptions } from '@/services/loyalty/loyalty.service';
import { CustomerProfile } from '@/models';
import { Routes } from '@/router';

@Component({
  name: 'CmgRewardsMembersOnlyModal'
})
export default class CmgRewardsMembersOnlyModal extends Vue {

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.rewardsMembersOnlyModal.visible;
  }

  get isGuest(): boolean {
    return this.$services.customer.isLoggedIn() !== true;
  }

  get mainCTAText(): string {
    if (this.isGuest) {
      return 'CREATE ACCOUNT';
    }
    return 'JOIN REWARDS'
  }

  close() {
    this.$services.ui.setModalVisibility('rewardsMembersOnlyModal', false);
  }

  async onClickMainCTA() {
    this.close();
    this.$services.bag.setBagVisibility(false);
    
    switch (this.mainCTAText) {
      case 'CREATE ACCOUNT':
        this.$router.push({ name: Routes.CreateAccount });
        break;
      case 'JOIN REWARDS':
        const enrollmentOptions: EnrollmentOptions = { customer: this.customer, pageTitle: document.title };
        await this.$services.loyalty.enrollInLoyalty(enrollmentOptions)
          .then(() => this.$services.ui.showOnboardingModal(this.$services.customer, this.customer ?? undefined))
          .catch(e => this.$services.logger.error('Something went wrong joining rewards', { error: e }));
        break;
    }
  }
}
